import { dateTimeToTimeWithPint, parseTimeInPint } from "@shared/common/utils/luxonHelpers";
import { Required } from "@tractie/components";
import { DateTime, Interval } from "luxon";

export class PintTimeInWindowValidator extends Required {
  private readonly window: Interval<true>;
  private readonly date: DateTime<true>;

  constructor(window: Interval<true>, date: DateTime<true>) {
    super(undefined, { getMessage: () => getValidationMessage(window) });

    this.window = window;
    this.date = date;
  }

  static get validatorName() {
    return "PintTimeInWindowValidator";
  }

  execute(modelValue: string, _param: string) {
    const newTime = parseTimeInPint(modelValue, this.date);

    if (!newTime) {
      return false;
    }

    return !this.isValidTime(newTime);
  }

  isValidTime(time: DateTime<true>) {
    return this.window.contains(time) || this.window.end.equals(time);
  }

  static getMessage() {
    return Promise.resolve("Time not in window");
  }
}

function getValidationMessage(window: Interval<true>) {
  const includeDay = window.start.day !== window.end.day;
  return `Vertrektijd moet vallen tussen ${getFormattedTime(window.start, includeDay)} en ${getFormattedTime(window.end, includeDay)}`;
}

function getFormattedTime(time: DateTime<true>, includeDay: boolean) {
  if (includeDay) {
    return `${time.toFormat("ccc")} ${dateTimeToTimeWithPint(time)}`;
  }
  return dateTimeToTimeWithPint(time);
}
